import { render } from "./PeriodDisplay.vue?vue&type=template&id=6cbb3e7c"
import script from "./PeriodDisplay.vue?vue&type=script&lang=js"
export * from "./PeriodDisplay.vue?vue&type=script&lang=js"

import "./PeriodDisplay.vue?vue&type=style&index=0&id=6cbb3e7c&lang=scss"
script.render = render

export default script